import React from "react";
import {controlPropTypes} from "../formhelpers";
import BaseCheckbox from "../BaseControls/Checkbox";
import PropTypes from "prop-types";

export default class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.onCommitChange = this.onCommitChange.bind(this);
    }

    onCommitChange(descriptor, value) {
        const { onCommitChange } = this.props;
        onCommitChange && onCommitChange(descriptor, value);
    }

    render() {
        const { descriptor, controlOnly, enabled, placeholder } = this.props;
        const selector = `control-container-${descriptor.key}`;

        if(descriptor.disableBehaviour === "hide" && !enabled) {
            // control is disabled and should be hidden.
            return null;
        }

        let control;
        if(placeholder || !controlOnly) {
            control = (
                <label>
                    <BaseCheckbox
                        {...this.props}
                        onCommitChange={this.onCommitChange}
                    />
                    {descriptor.label}
                </label>
            );
        }
        else {
            control = (
                <BaseCheckbox
                    {...this.props}
                    onCommitChange={this.onCommitChange}
                />
            );
        }
        const ControlContainer = (
            <div
                id={descriptor.id}
                className={`${selector} ${placeholder ? "checkbox" : ""} control react-control checkbox-field ${ controlOnly ? "control-only" : "" }`}
                data-control-type={descriptor.control}
                data-shortname={descriptor.key}
            >
                {control}
            </div>
        );

        if(controlOnly) {
            return ControlContainer;
        }

        return (
            <div className="form-item">
                <div className="left-side">
                </div>
                <div className="right-side checkbox">
                    {ControlContainer}
                </div>
            </div>
        );

    }
}

Checkbox.propTypes = controlPropTypes({
    copyOnClickMappings: PropTypes.arrayOf(
        PropTypes.shape({
            source: PropTypes.string.isRequired,
            target: PropTypes.string.isRequired,
        })
    ),
    checkedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.bool,PropTypes.number]),
    uncheckedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.bool,PropTypes.number]),
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/ChoiceField/checkbox.js